<template>
  <div class="main-user">
    <el-card>
      <div slot="header" class="clearfix">
        <span>基本信息</span>
      </div>
      <el-row>
        <el-form
          :model="userInfo"
          label-position="right"
          :rules="userRules"
          inline
          class="demo-ruleForm"
          label-width="100px"
          size="small"
          ref="userInfo"
        >
          <el-col :span="8">
            <el-form-item label="姓名:" prop="realName">
              <el-input
                v-model="userInfo.realName"
                placeholder="姓名"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="手机号:" prop="mphone">
              <el-input
                v-model="userInfo.mphone"
                placeholder="手机号"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="性别:">
              <el-select
                v-model="userInfo.sex"
                placeholder="性别"
                clearable
              >
                <el-option
                  v-for="item in sexs"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="电子邮箱:">
              <el-input
                v-model="userResumeInfo.email"
                placeholder="电子邮箱"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出生日期:">
              <el-date-picker
                v-model="userResumeInfo.birthday"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="居住地:">
              <el-input
                v-model="userResumeInfo.address"
                placeholder="居住地"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="民族:">
              <el-select
                  v-model="userResumeInfo.nationality"
                  placeholder="民族"
                  clearable
              >
                <el-option
                    v-for="item in nationalityOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="最高学历:">
              <el-select
                v-model="userResumeInfo.education"
                placeholder="最高学历"
                clearable
              >
                <el-option
                  v-for="item in eduOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="政治面貌:">
              <el-select
                v-model="userResumeInfo.politicalStatus"
                placeholder="政治面貌"
                clearable
              >
                <el-option
                  v-for="item in capacityOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="专业:">
              <el-input
                v-model="userResumeInfo.major"
                placeholder="专业"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="证件号码:" prop="idNumber">
              <el-input
                v-model="userInfo.idNumber"
                placeholder="证件号码"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="毕业院校:">
              <el-input
                v-model="userResumeInfo.graduateSchool"
                placeholder="毕业院校"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="工作年限:">
              <el-input-number
                  v-model="userResumeInfo.workYear"
                  :min="0"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="证件照" prop="idPhoto">
              <image-uploader
                ref="imageUploader"
                :upload-callback="submitUserInfo"
                :file-name="userInfo.idNumber"
                v-model="userInfo.idPhoto"
                upload-path="id-photo-pending"
                :width="100"
                :height="140"
              ></image-uploader>
              <div style="color:red;">
                建议图片尺寸为626*413像素
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24" align="center">
            <el-button @click="onSubmitUserInfo">保存</el-button>
            <el-button @click="cancelResume">重置</el-button>
          </el-col>
        </el-form>
      </el-row>
    </el-card>
    <div class="blank"></div>
    <el-card>
      <div slot="header" class="clearfix">
        <span>教育经历</span>
        <div class="add_button">
          <el-tooltip
            class="item"
            effect="dark"
            content="添加"
            placement="top-start"
          >
            <el-button
              icon="el-icon-circle-plus-outline"
              circle
              size="mini"
              type="primary"
              @click="onAddEdu"
            ></el-button>
          </el-tooltip>
        </div>
      </div>
      <el-card v-for="(item, index) in resumeEduInfoList" :key="index">
        <div slot="header" class="clearfix">
          <span>{{ item.school }}</span>
        </div>
        <el-row>
          <el-form inline size="small">
            <el-col :span="20">
              <el-row>
                <el-col :span="5">
                  <el-form-item label="专业:">
                    {{ item.major }}
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="学历:">
                    {{ item.education }}
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="毕业时间:">
                    {{ item.endTime }}年毕业
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item align="center">
                    <el-button type="text" @click="showEduFiles(item.id)"
                      >查看学历附件</el-button
                    >
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-form>
          <el-form>
            <el-col :span="4">
              <div class="button">
                <img @click="onEditEdu(item.id)" src="@/assets/button02.png" />
                <img @click="onDelEdu(item.id)" src="@/assets/button01.png" />
              </div>
            </el-col>
          </el-form>
        </el-row>
      </el-card>
    </el-card>
    <div class="blank"></div>
    <el-card>
      <div slot="header" class="clearfix">
        <span>实习经历</span>
        <div class="add_button">
          <el-tooltip
            class="item"
            effect="dark"
            content="添加"
            placement="top-start"
          >
            <el-button
              icon="el-icon-circle-plus-outline"
              circle
              size="mini"
              type="primary"
              @click="onAddInternship"
            ></el-button>
          </el-tooltip>
        </div>
      </div>
      <el-card v-for="(item, index) in resumeInternshipInfoList" :key="index">
        <div slot="header" class="clearfix">
          <span>{{ item.companyName }}</span>
        </div>
        <el-row>
          <el-form inline size="small">
            <el-col :span="20">
              <el-row>
                <el-col :span="6">
                  <el-form-item label="职位:">
                    {{ item.position }}
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="实习时间:">
                    {{ item.startTime }}至{{ item.endTime }}
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="工作内容:">
                    {{ item.workContent }}
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-form>
          <el-col :span="4">
            <div class="button">
              <img
                @click="onEditInternship(item.id)"
                src="@/assets/button02.png"
              />
              <img
                @click="onDelInternship(item.id)"
                src="@/assets/button01.png"
              />
            </div>
          </el-col>
        </el-row>
      </el-card>
    </el-card>
    <div class="blank"></div>
    <el-card>
      <div slot="header" class="clearfix">
        <span>工作经历</span>
        <div class="add_button">
          <el-tooltip
            class="item"
            effect="dark"
            content="添加"
            placement="top-start"
          >
            <el-button
              icon="el-icon-circle-plus-outline"
              circle
              type="primary"
              size="mini"
              @click="onAddWork"
            ></el-button>
          </el-tooltip>
        </div>
      </div>
      <el-card :key="item.id" v-for="item in resumeWorkInfoList">
        <div slot="header" class="clearfix">
          <span>{{ item.companyName }}</span>
        </div>
        <el-row>
          <el-form inline size="small">
            <el-col :span="20">
              <el-row>
                <el-col :span="6">
                  <el-form-item label="单位性质:">
                    {{ item.companyType }}
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="行业类别:">
                    {{ item.tradeType }}
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="职位:">
                    {{ item.position }}
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="在职时间:">
                    {{ item.startTime }}至{{ item.endTime }}
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="工作内容:">
                    {{ item.workContent }}
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-form>
          <el-col :span="4">
            <div class="button">
              <img @click="onEditWork(item.id)" src="@/assets/button02.png" />
              <img @click="onDelWork(item.id)" src="@/assets/button01.png" />
            </div>
          </el-col>
        </el-row>
      </el-card>
    </el-card>
    <div class="blank"></div>
    <el-card>
      <div slot="header" class="clearfix">
        <span>项目经历</span>
        <div class="add_button">
          <el-tooltip
            class="item"
            effect="dark"
            content="添加"
            placement="top-start"
          >
            <el-button
              icon="el-icon-circle-plus-outline"
              circle
              type="primary"
              size="mini"
              @click="onAddProject"
            ></el-button>
          </el-tooltip>
        </div>
      </div>
      <el-card v-for="(item, index) in resumeProjectInfoList" :key="index">
        <div slot="header" class="clearfix">
          <span>{{ item.projectName }}</span>
        </div>
        <el-row>
          <el-form inline size="small">
            <el-col :span="20">
              <el-row>
                <el-col :span="6">
                  <el-form-item label="项目时间:">
                    {{ item.startTime }}至{{ item.endTime }}
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="主要职责:">
                    {{ item.projectDuty }}
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="项目成果:">
                    {{ item.projectResult }}
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-form>
          <el-col :span="4">
            <div class="button">
              <img
                @click="onEditProject(item.id)"
                src="@/assets/button02.png"
              />
              <img @click="onDelProject(item.id)" src="@/assets/button01.png" />
            </div>
          </el-col>
        </el-row>
      </el-card>
    </el-card>
    <div class="blank"></div>
    <el-card>
      <div slot="header" class="clearfix">
        <span>培训信息</span>
        <div class="add_button">
          <el-tooltip
            class="item"
            effect="dark"
            content="添加"
            placement="top-start"
          >
            <el-button
              icon="el-icon-circle-plus-outline"
              circle
              type="primary"
              size="mini"
              @click="onAddTraining"
            ></el-button>
          </el-tooltip>
        </div>
      </div>
      <el-card :key="item.id" v-for="item in resumeTrainingInfoList">
        <div slot="header" class="clearfix">
          <span>{{ item.trainingCompany }}</span>
        </div>
        <el-row>
          <el-form inline size="small">
            <el-col :span="20">
              <el-row>
                <!--                <el-col :span="5">-->
                <!--                  <el-form-item label="培训时间:">-->
                <!--                    {{item.startTime ? item.startTime + ' 至 ' : '' }}{{ item.startTime && item.endTime ? item.endTime : '' }}-->
                <!--                  </el-form-item>-->
                <!--                </el-col>-->
                <el-col :span="5">
                  <el-form-item label="科目名称:">
                    {{ item.courseName }}
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="培训等级:">
                    {{ item.trainingLevel }}
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="证书编号:">
                    {{ item.certificateNo }}
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="证件类型:">
                    {{ item.certificateType }}
                  </el-form-item>
                </el-col>
                <!--                <el-col :span="5">-->
                <!--                  <el-form-item label="培训内容:">-->
                <!--                    {{ item.trainingContent }}-->
                <!--                  </el-form-item>-->
                <!--                </el-col>-->
                <el-col :span="5">
                  <el-form-item align="center">
                    <el-button type="text" @click="showTrainingFiles(item.id)"
                    >查看成绩附件</el-button
                    >
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>

                <el-col :span="5">
                  <el-form-item label="培训学时:">
                    {{ item.trainingHours }}
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="评定成绩:">
                    {{ item.achievements }}
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-form>
          <el-col :span="4">
            <div class="button">
              <img
                @click="onEditTraining(item.id)"
                src="@/assets/button02.png"
              />
              <img
                @click="onDelTraining(item.id)"
                src="@/assets/button01.png"
              />
            </div>
          </el-col>
        </el-row>
      </el-card>
    </el-card>
    <div class="blank"></div>
    <el-card>
      <div slot="header" class="clearfix">
        <span>所获荣誉</span>
        <div class="add_button">
          <el-tooltip
            class="item"
            effect="dark"
            content="添加"
            placement="top-start"
          >
            <el-button
              icon="el-icon-circle-plus-outline"
              circle
              type="primary"
              size="mini"
              @click="onAddCertificate"
            ></el-button>
          </el-tooltip>
        </div>
      </div>
      <el-card v-for="(item, index) in resumeCertificateInfoList" :key="index">
        <div slot="header" class="clearfix">
          <span>{{ item.certificateName }}</span>
        </div>
        <el-row>
          <el-form inline size="small">
            <el-col :span="20">
              <el-row>
                <el-col :span="6">
                  <el-form-item label="发证单位:">
                    {{ item.issuedBy }}
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="获奖时间:">
                    {{ item.winningTime }}
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-button type="text" @click="showCertificateFiles(item.id)"
                    >查看证书</el-button
                  >
                </el-col>
              </el-row>
            </el-col>
          </el-form>
          <el-col :span="4">
            <div class="button">
              <img
                @click="onEditCertificate(item.id)"
                src="@/assets/button02.png"
              />
              <img
                @click="onDelCertificate(item.id)"
                src="@/assets/button01.png"
              />
            </div>
          </el-col>
        </el-row>
      </el-card>
    </el-card>
    <el-dialog
      :visible.sync="eduEditVisible"
      title="教育经历"
      @close="resetForm('eduForm')"
      destroy-on-clos
    >
      <el-form
        v-if="eduEditVisible"
        :model="eduForm"
        :rules="eduRules"
        ref="eduForm"
        label-width="100px"
      >
        <el-form-item label="学校名称:" required prop="school">
          <el-input v-model="eduForm.school" />
        </el-form-item>
        <el-form-item label="专业:" prop="major">
          <el-input v-model="eduForm.major" />
        </el-form-item>
        <el-form-item label="学历:" required prop="education">
          <el-select v-model="eduForm.education">
            <!--<el-option label="小学" value="小学"></el-option>
            <el-option label="初中" value="初中"></el-option>-->
            <el-option label="高中" value="高中"></el-option>
            <el-option label="专科" value="专科"></el-option>
            <el-option label="本科" value="本科"></el-option>
            <el-option label="硕士" value="硕士"></el-option>
            <el-option label="博士" value="博士"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学位" prop="degree">
          <el-input v-model="eduForm.degree"></el-input>
        </el-form-item>
        <el-form-item label="时间段" prop="startTime">
          <el-date-picker
            v-model="timeRange"
            type="monthrange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            style="width: 100%;"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="其他:" prop="serve">
          <el-input v-model="eduForm.serve" />
        </el-form-item>
        <el-form-item label="学历附件:" prop="uploadEducationAnnex">
          <image-uploader
            v-if="eduEditVisible"
            ref="eduUploader"
            :upload-callback="saveEdu"
            :file-name="userInfo.idNumber + new Date().getTime()"
            v-model="eduForm.uploadEducationAnnex"
            upload-path="resume-education-file"
            :width="100"
            :height="140"
          ></image-uploader>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSaveEdu" :loading="saveEduBth"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="eduFileVisible" title="学历附件">
      <image-uploader
        v-model="eduForm.uploadEducationAnnex"
        preview
        :width="100"
        :height="140"
      ></image-uploader>
    </el-dialog>
    <el-dialog
      destroy-on-close
      :visible.sync="internshipEditVisible"
      title="实习经历"
      @close="resetForm('internshipForm')"
    >
      <el-form
        :model="internshipForm"
        :rules="internshipRules"
        ref="internshipForm"
        label-width="100px"
      >
        <el-form-item label="公司名称:" required prop="companyName">
          <el-input v-model="internshipForm.companyName" />
        </el-form-item>
        <el-form-item label="职位:" required prop="position">
          <el-input v-model="internshipForm.position" />
        </el-form-item>
        <el-form-item label="在职时间:" required>
          <el-col :span="11">
            <el-form-item prop="startTime">
              <el-date-picker
                v-model="internshipForm.startTime"
                style="width: 100%;"
                type="month"
                format="yyyy-MM"
                :editable="false"
                placeholder="开始日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="2" align="center">至</el-col>
          <el-col :span="11">
            <el-form-item prop="endTime">
              <el-date-picker
                v-model="internshipForm.endTime"
                style="width: 100%;"
                type="month"
                format="yyyy-MM"
                :editable="false"
                placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="工作内容:" prop="workContent">
          <el-input type="textarea" v-model="internshipForm.workContent" />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="onSaveInternship"
            :loading="saveInternshipBth"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :visible.sync="workEditVisible"
      title="工作经历"
      @close="resetForm('workForm')"
    >
      <el-form
        :model="workForm"
        :rules="workRules"
        ref="workForm"
        label-width="100px"
      >
        <el-form-item label="公司名称:" required prop="companyName">
          <el-input v-model="workForm.companyName" />
        </el-form-item>
        <el-form-item label="单位性质:" prop="companyType">
          <el-select v-model="workForm.companyType">
            <el-option label="国家行政机关" value="国家行政机关"></el-option>
            <el-option label="事业单位" value="事业单位"></el-option>
            <el-option label="国有企业" value="国有企业"></el-option>
            <el-option label="外资企业" value="外资企业"></el-option>
            <el-option label="合资企业" value="合资企业"></el-option>
            <el-option label="民营企业" value="民营企业"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="行业类别:" prop="tradeType">
          <el-select v-model="workForm.tradeType">
            <el-option label="农、林、牧、渔业" value="农、林、牧、渔业"></el-option>
            <el-option label="采矿业" value="采矿业"></el-option>
            <el-option label="制造业" value="制造业"></el-option>
            <el-option label="电力、热力、燃气及水生产和供应业" value="电力、热力、燃气及水生产和供应业"></el-option>
            <el-option label="建筑业" value="建筑业"></el-option>
            <el-option label="批发和零售业" value="批发和零售业"></el-option>
            <el-option label="交通运输、仓储和邮政业" value="交通运输、仓储和邮政业"></el-option>
            <el-option label="住宿和餐饮业" value="住宿和餐饮业"></el-option>
            <el-option label="信息传输、软件和信息技术服务业" value="信息传输、软件和信息技术服务业"></el-option>
            <el-option label="金融业" value="金融业"></el-option>
            <el-option label="房地产业" value="房地产业"></el-option>
            <el-option label="租赁和商务服务业" value="租赁和商务服务业"></el-option>
            <el-option label="科学研究和技术服务业" value="科学研究和技术服务业"></el-option>
            <el-option label="水利、环境和公共设施管理业" value="水利、环境和公共设施管理业"></el-option>
            <el-option label="居民服务、修理和其他服务业" value="居民服务、修理和其他服务业"></el-option>
            <el-option label="教育" value="教育"></el-option>
            <el-option label="卫生和社会工作" value="卫生和社会工作"></el-option>
            <el-option label="文化、体育和娱乐业" value="文化、体育和娱乐业"></el-option>
            <el-option label="公共管理、社会保障和社会组织" value="公共管理、社会保障和社会组织"></el-option>
            <el-option label="国际组织" value="国际组织"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="职位:" required prop="position">
          <el-input v-model="workForm.position" />
        </el-form-item>
        <el-form-item label="在职时间:" required>
          <el-col :span="11">
            <el-form-item prop="startTime">
              <el-date-picker
                v-model="workForm.startTime"
                style="width: 100%;"
                type="month"
                format="yyyy-MM"
                :editable="false"
                placeholder="开始日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="2" align="center">至</el-col>
          <el-col :span="11">
            <el-form-item prop="endTime">
              <el-date-picker
                v-model="workForm.endTime"
                style="width: 100%;"
                type="month"
                format="yyyy-MM"
                :editable="false"
                placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="工作内容:" prop="workContent">
          <el-input type="textarea" v-model="workForm.workContent" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSaveWork" :loading="saveWorkBth"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :visible.sync="projectEditVisible"
      title="项目经历"
      @close="resetForm('projectForm')"
    >
      <el-form
        :model="projectForm"
        :rules="projectRules"
        ref="projectForm"
        label-width="100px"
      >
        <el-form-item label="项目名称:" required prop="projectName">
          <el-input v-model="projectForm.projectName" />
        </el-form-item>
        <el-form-item label="项目周期:" required>
          <el-col :span="11">
            <el-form-item prop="startTime">
              <el-date-picker
                v-model="projectForm.startTime"
                style="width: 100%;"
                type="month"
                format="yyyy-MM"
                :editable="false"
                placeholder="开始日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="2" align="center">至</el-col>
          <el-col :span="11">
            <el-form-item prop="endTime">
              <el-date-picker
                v-model="projectForm.endTime"
                style="width: 100%;"
                type="month"
                format="yyyy-MM"
                :editable="false"
                placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="主要职责:" prop="projectDuty">
          <el-input type="textarea" v-model="projectForm.projectDuty" />
        </el-form-item>
        <el-form-item label="项目成果:" prop="projectResult">
          <el-input type="textarea" v-model="projectForm.projectResult" />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="onSaveProject"
            :loading="saveProjectBth"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :visible.sync="trainingEditVisible"
      title="培训经历"
      @close="resetForm('trainingForm')"
      destroy-on-close
    >
      <el-form
        :model="trainingForm"
        :rules="trainingRules"
        ref="trainingForm"
        label-width="100px"
      >
        <el-form-item label="机构名称:" required prop="trainingCompany">
          <el-input v-model="trainingForm.trainingCompany" />
        </el-form-item>
        <el-form-item label="培训等级:" prop="trainingLevel">
          <el-input v-model="trainingForm.trainingLevel" />
        </el-form-item>
<!--        <el-form-item label="培训周期:" required>-->
<!--          <el-col :span="11">-->
<!--            <el-form-item prop="startTime">-->
<!--              <el-date-picker-->
<!--                v-model="trainingForm.startTime"-->
<!--                style="width: 100%;"-->
<!--                type="month"-->
<!--                format="yyyy-MM"-->
<!--                :editable="false"-->
<!--                placeholder="开始日期"-->
<!--              >-->
<!--              </el-date-picker>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--          <el-col :span="2" align="center">至</el-col>-->
<!--          <el-col :span="11">-->
<!--            <el-form-item prop="endTime">-->
<!--              <el-date-picker-->
<!--                v-model="trainingForm.endTime"-->
<!--                style="width: 100%;"-->
<!--                type="month"-->
<!--                format="yyyy-MM"-->
<!--                :editable="false"-->
<!--                placeholder="结束日期"-->
<!--              >-->
<!--              </el-date-picker>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--        </el-form-item>-->
        <el-form-item label="科目名称:" prop="courseName">
          <el-input type="textarea" v-model="trainingForm.courseName" />
        </el-form-item>
        <!--        <el-form-item label="培训内容:" prop="trainingContent">-->
        <!--          <el-input type="textarea" v-model="trainingForm.trainingContent" />-->
        <!--        </el-form-item>-->
        <el-form-item label="证书编号:" prop="certificateNo">
          <el-input type="textarea" v-model="trainingForm.certificateNo" />
        </el-form-item>
        <el-form-item label="证件类型:" prop="certificateType">
          <el-input type="textarea" v-model="trainingForm.certificateType" />
        </el-form-item>
        <el-form-item label="培训学时:" prop="trainingHours">
          <el-input type="textarea" v-model="trainingForm.trainingHours" />
        </el-form-item>
        <el-form-item label="评定成绩:" prop="achievements">
          <el-input type="textarea" v-model="trainingForm.achievements" />
        </el-form-item>
        <el-form-item label="成绩附件:" prop="uploadProof">
          <image-uploader
            ref="trainingUploader"
            :upload-callback="saveTraining"
            :file-name="userInfo.idNumber + new Date().getTime()"
            v-model="trainingForm.uploadProof"
            upload-path="resume-training-file"
            :width="100"
            :height="140"
          ></image-uploader>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="onSaveTraining"
            :loading="saveTrainingBth"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="trainingFileVisible" title="成绩附件">
      <image-uploader
        v-model="trainingForm.uploadProof"
        preview
        :width="100"
        :height="140"
      ></image-uploader>
    </el-dialog>
    <el-dialog
      :visible.sync="certificateEditVisible"
      title="所获荣誉"
      @close="resetForm('certificateForm')"
    >
      <el-form
        :model="certificateForm"
        :rules="certificateRules"
        ref="certificateForm"
        label-width="100px"
      >
        <el-form-item label="证书名称:" required prop="certificateName">
          <el-input v-model="certificateForm.certificateName" />
        </el-form-item>
        <el-form-item label="发证单位:" prop="issuedBy">
          <el-input v-model="certificateForm.issuedBy" />
        </el-form-item>
        <el-form-item label="获奖时间:" required prop="winningTime">
          <el-col :span="12">
            <el-form-item prop="endTime">
              <el-date-picker
                type="month"
                :editable="false"
                placeholder="选择日期"
                v-model="certificateForm.winningTime"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="证书附件" prop="uploadProof">
          <image-uploader
            ref="certificateUploader"
            :upload-callback="saveCertificate"
            :file-name="userInfo.idNumber + new Date().getTime()"
            v-model="certificateForm.uploadCertificate"
            upload-path="resume-certificate-photo"
            :width="100"
            :height="140"
          ></image-uploader>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="onSaveCertificate"
            :loading="saveCertificateBth"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="certificateFileVisible" title="证书附件">
      <image-uploader
        v-model="certificateForm.uploadCertificate"
        preview
        :width="100"
        :height="140"
      ></image-uploader>
    </el-dialog>
  </div>
</template>

<script>
import {
  findUser,
  updateUser,
  mergeAccount,
  findUserResumeInfo,
  updateUserResumeInfo,
  getResumeCertificateList,
  findResumeCertificate,
  addResumeCertificate,
  updateResumeCertificate,
  deleteResumeCertificate,
  getResumeEducationList,
  findResumeEducation,
  addResumeEducation,
  updateResumeEducation,
  deleteResumeEducation,
  getResumeInternshipList,
  findResumeInternship,
  addResumeInternship,
  updateResumeInternship,
  deleteResumeInternship,
  getResumeProjectList,
  findResumeProject,
  addResumeProject,
  updateResumeProject,
  deleteResumeProject,
  getResumeTrainingList,
  findResumeTraining,
  addResumeTraining,
  updateResumeTraining,
  deleteResumeTraining,
  getResumeWorkList,
  findResumeWork,
  addResumeWork,
  updateResumeWork,
  deleteResumeWork
} from "@/api/userInfo";
import permission from "@/directive/permission"; // 权限判断指令
import { getToken, getAgentUserId, getAgentId } from "@/utils/auth";
import ImageUploader from "@/components/imageUploader";
export default {
  name: "editUser",
  components: {
    ImageUploader
  },
  directives: { permission },
  data() {
    return {
      headers: {
        Authorization: getToken(),
        Authorizator: getAgentUserId(),
        Organization: getAgentId()
      },
      userId: null,
      mphoneFlag: null,
      userResumeInfo: {
        userId: null,
        sex: null,
        birthday: "",
        nationality: "",
        politicalStatus: null,
        email: "",
        address: "",
        education: "",
        major: "",
        workYear: undefined,
        graduateSchool: ""
      },
      userInfo: {
        userId: null,
        realName: "",
        mphone: "",
        idPhoto: "",
        idNumber: ""
      },
      registerDate: ["", ""],
      userFromOptions: [
        { label: "自行注册", value: "1" },
        { label: "机构", value: "2" }
      ],
      auditStatusOptions: [
        { label: "已通过", value: "1" },
        { label: "未通过", value: "2" },
        { label: "未审核", value: "3" }
      ],
      sexs: [
        { label: "男", value: 1 },
        { label: "女", value: 2 }
      ],
      eduOptions: [
        { label: "高中", value: "高中" },
        { label: "专科", value: "专科" },
        { label: "本科", value: "本科" },
        { label: "硕士", value: "硕士" },
        { label: "博士", value: "博士" },
        { label: "其他", value: "其他" }
      ],
      capacityOptions: [
        { label: "群众", value: "群众" },
        { label: "团员", value: "团员" },
        { label: "党员", value: "党员" }
      ],
      nationalityOptions: [
        '汉族',
        '壮族',
        '回族',
        '满族',
        '维吾尔族',
        '苗族',
        '彝族',
        '土家族',
        '藏族',
        '蒙古族',
        '侗族',
        '布依族',
        '瑶族',
        '白族',
        '朝鲜族',
        '哈尼族',
        '黎族',
        '哈萨克族',
        '傣族',
        '畲族',
        '傈僳族',
        '东乡族',
        '仡佬族',
        '拉祜族',
        '佤族',
        '水族',
        '纳西族',
        '羌族',
        '土族',
        '仫佬族',
        '锡伯族',
        '柯尔克孜族',
        '景颇族',
        '达斡尔族',
        '撒拉族',
        '布朗族',
        '毛南族',
        '塔吉克族',
        '普米族',
        '阿昌族',
        '怒族',
        '鄂温克族',
        '京族',
        '基诺族',
        '德昂族',
        '保安族',
        '俄罗斯族',
        '裕固族',
        '乌孜别克族',
        '门巴族',
        '鄂伦春族',
        '独龙族',
        '赫哲族',
        '高山族',
        '珞巴族',
        '塔塔尔族',
      ],
      uploadCallback: null,
      loading: false,
      importPhoneVisible: false,
      isUserEdit: false,
      loadingInstance: null,
      serviceCount: 0,
      resumeEduInfoList: [],
      eduEditVisible: false,
      internshipEditVisible: false,
      projectEditVisible: false,
      trainingEditVisible: false,
      workEditVisible: false,
      certificateEditVisible: false,
      timeRange: [],
      eduForm: {
        school: "",
        major: "",
        education: "",
        startTime: "",
        endTime: "",
        uploadEducationAnnex: "",
        degree: ""
      },
      internshipForm: {
        companyName: "",
        position: "",
        startTime: "",
        endTime: "",
        workContent: ""
      },
      projectForm: {
        projectName: "",
        startTime: "",
        endTime: "",
        projectDuty: "",
        projectResult: ""
      },
      trainingForm: {
        trainingCompany: "",
        trainingLevel: "",
        trainingContent: "",
        achievements: "",
        uploadProof: "",
        certificateType: "",
        certificateNo: "",
        courseName: "",
        trainingHours: "",
      },
      workForm: {
        companyName: "",
        companyType: "",
        tradeType: "",
        position: "",
        startTime: "",
        endTime: "",
        workContent: ""
      },
      certificateForm: {
        certificateName: "",
        issuedBy: "",
        winningTime: "",
        uploadCertificate: ""
      },
      userRules: {
        realName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        mphone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[0-9]\d{9}$/,
            message: "请输入正确的手机号",
            trigger: "blur,change"
          }
        ],
        idNumber: [
          { required: true, message: "请输入证件号码", trigger: "blur" },
          { min: 7, message: "最少7个字符", trigger: "blur" }
        ]
      },
      eduRules: {
        school: [
          { required: true, message: "请输入学校名称", trigger: "blur" }
        ],
        education: [{ required: true, message: "请选择学历", trigger: "blur" }],
        startTime: [
          { required: true, message: "请选择开始时间", trigger: "blur" }
        ],
        endTime: [
          { required: true, message: "请选择结束时间 ", trigger: "blur" }
        ]
      },
      internshipRules: {
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "blur" }
        ],
        position: [
          { required: true, message: "请输入职位名称", trigger: "blur" }
        ],
        startTime: [
          { required: true, message: "请选择开始时间", trigger: "blur" }
        ],
        endTime: [
          { required: true, message: "请选择结束时间 ", trigger: "blur" }
        ]
      },
      projectRules: {
        projectName: [
          { required: true, message: "请输入项目名称", trigger: "blur" }
        ],
        startTime: [
          { required: true, message: "请选择开始时间", trigger: "blur" }
        ],
        endTime: [
          { required: true, message: "请选择结束时间", trigger: "blur" }
        ]
      },
      trainingRules: {
        trainingCompany: [
          { required: true, message: "请输入培训机构名称", trigger: "blur" }
        ],
        // startTime: [
        //   { required: true, message: "请选择开始时间", trigger: "blur" }
        // ],
        // endTime: [
        //   { required: true, message: "请选择结束时间", trigger: "blur" }
        // ]
      },
      workRules: {
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "blur" }
        ],
        companyType: [
          { required: true, message: "请选择单位性质", trigger: "change" }
        ],
        tradeType: [
          { required: true, message: "请选择行业类别", trigger: "change" }
        ],
        position: [
          { required: true, message: "请输入职位名称", trigger: "blur" }
        ],
        startTime: [
          { required: true, message: "请选择开始时间", trigger: "blur" }
        ],
        endTime: [
          { required: true, message: "请选择结束时间 ", trigger: "blur" }
        ]
      },
      certificateRules: {
        certificateName: [
          { required: true, message: "请输入证书名称", trigger: "blur" }
        ],
        issuedBy: [
          { required: true, message: "请输入发证单位名称", trigger: "blur" }
        ]
      },
      saveEduBth: false,
      saveInternshipBth: false,
      saveProjectBth: false,
      saveTrainingBth: false,
      saveWorkBth: false,
      saveCertificateBth: false,
      resumeInternshipInfoList: [],
      resumeProjectInfoList: [],
      resumeTrainingInfoList: [],
      resumeWorkInfoList: [],
      resumeCertificateInfoList: [],
      eduFileVisible: false,
      trainingFileVisible: false,
      certificateFileVisible: false
    };
  },
  watch: {
    "userInfo.userId"(val) {
      if (val) {
        this.onFindUserInfo(this.userInfo.userId);
      }
    },
    serviceCount(val) {
      if (val === 7) {
        this.loadingInstance.close();
      }
    },
    timeRange(val) {
      if (val && val.length === 2) {
        this.eduForm.startTime = val[0];
        this.eduForm.endTime = val[1];
      }
    }
  },
  computed: {},
  created() {
    if (this.$route.query.id) {
      this.userId = this.$route.query.id;
      this.userInfo.userId = this.$route.query.id;
      this.userResumeInfo.userId = this.$route.query.id;
      this.init();
    }
  },
  methods: {
    init() {
      let that = this;
      that.loadingInstance = that.$loading(false);
      that.onFindUserInfo();
      that.onFindUserResumeInfo();
      that.onGetResumeEducationList();
      that.onGetResumeInternshipList();
      that.onGetResumeProjectList();
      that.onGetResumeTrainingList();
      that.onGetResumeWorkList();
      that.onGetResumeCertificateList();
      this.timeRange = [];
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    formatYear(d) {
      let date = new Date(d);
      let year = date.getFullYear();
      return year;
    },
    formatDate(d) {
      let date = new Date(d);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      return [year, month, day].map(this.formatNumber).join("-") + " 00:00:00";
    },
    formatMonth(d) {
      let date = new Date(d);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      return [year, month].map(this.formatNumber).join("-");
    },
    formatNumber(n) {
      n = n.toString();
      return n[1] ? n : "0" + n;
    },
    // 个人基础信息
    onFindUserInfo() {
      findUser(this.userId).then(res => {
        if (res && res.code === 200) {
          this.userInfo = res.data;
        }
      });
    },
    onFindUserResumeInfo() {
      let that = this;
      findUserResumeInfo(that.userId).then(res => {
        that.serviceCount++;
        if (res && res.code === 200) {
          if (res.data) {
            that.userResumeInfo = res.data;
            if (res.data.workYear === null || res.data.workYear === '') {
              res.data.workYear = undefined
            }
          }
        }
      });
    },
    onSubmitUserInfo() {
      this.$confirm("保存基本信息将同步修改用户证书信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          if (
            this.userInfo.idPhoto &&
            this.userInfo.idPhoto.indexOf("data:") !== -1
          ) {
            this.$refs["imageUploader"].submit();
          } else {
            this.$refs["userInfo"].validate(valid => {
              if (valid) {
                this.loadingInstance = this.$loading(false);
                this.submitUserInfo(() => {
                  this.loadingInstance.close();
                });
              } else {
                return false;
              }
            });
          }
        })
        .catch(() => {});
    },
    submitUserInfo(callback) {
      let that = this;
      that.userResumeInfo.userId = that.userId;
      let userResumeInfo = JSON.parse(JSON.stringify(that.userResumeInfo))
      if (userResumeInfo.workYear === undefined) {
        userResumeInfo.workYear = '';
      }
      updateUserResumeInfo(userResumeInfo).then(res => {
        if (res && res.code === 200) {
          updateUser(that.userId, that.userInfo).then(res => {
            if (res && res.code === 200) {
              if (res.data === "exist") {
                that
                  .$confirm(
                    "您的手机号或者证件号码已存在账户,是否需要合并账户?",
                    "提示",
                    {
                      confirmButtonText: "确定",
                      cancelButtonText: "取消",
                      type: "warning"
                    }
                  )
                  .then(() => {
                    that.mergeAccount();
                  })
                  .catch(() => {});
                return false;
              }
              that.$message.success("保存成功");
              that.onFindUserInfo();
              that.onFindUserResumeInfo();
            }
            if (callback && callback instanceof Function) {
              callback();
            }
          });
        }
      });
    },
    mergeAccount() {
      this.loadingInstance = this.$loading(false);
      mergeAccount(this.userId, this.userInfo.mphone);
      this.loadingInstance.close();
      /*if (res && res.code === 200) {
        this.$message({
          message: "收到合并请求,请10分钟后登录系统",
          type: "success"
        });
      }*/
    },
    cancelResume() {
      (this.userInfo.realName = ""),
        (this.userInfo.sex = null),
        (this.userInfo.birthday = ""),
        (this.userInfo.mphone = ""),
        (this.userInfo.nationality = ""),
        (this.userInfo.politicalStatus = ""),
        (this.userInfo.email = ""),
        (this.userInfo.address = ""),
        (this.userInfo.education = ""),
        (this.userInfo.major = ""),
        (this.userInfo.workYear = ""),
        (this.userInfo.graduateSchool = "");
    },
    // 教育经历
    onGetResumeEducationList() {
      let that = this;
      getResumeEducationList(this.userId).then(res => {
        if (res && res.code === 200) {
          that.serviceCount++;
          if (res.data) {
            that.resumeEduInfoList = res.data.map(item => {
              if (item.endTime) {
                item.endTime = that.formatYear(item.endTime);
              }
              return item;
            });
          }
        }
      });
    },
    onFindEduInfo(id, callback) {
      let that = this;
      findResumeEducation(id).then(res => {
        if (res && res.code === 200) {
          if (res.data) {
            that.eduForm = res.data;
            if (that.eduForm.startTime && that.eduForm.endTime) {
              that.timeRange.push(that.eduForm.startTime);
              that.timeRange.push(that.eduForm.endTime);
            }
            if (
              that.eduForm.uploadEducationAnnex &&
              that.eduForm.uploadEducationAnnex.length > 0
            ) {
              that.eduForm.uploadEducationAnnex = JSON.parse(
                that.eduForm.uploadEducationAnnex
              )[0];
            }
            if (callback && callback instanceof Function) {
              callback();
            }
          }
        }
      });
    },
    onSaveEdu() {
      let that = this;
      that.$refs["eduForm"].validate(valid => {
        if (valid) {
          if (
            that.eduForm.uploadEducationAnnex &&
            that.eduForm.uploadEducationAnnex.startsWith("data:image")
          ) {
            that.uploadResumeEducationFile();
          } else {
            that.saveEdu();
          }
        } else {
          return false;
        }
      });
    },
    saveEdu() {
      let that = this;
      try {
        that.saveEduBth = true;
        let data = this._.cloneDeep(this.eduForm);
        if (data.uploadEducationAnnex) {
          let arr = [];
          arr.push(data.uploadEducationAnnex);
          data.uploadEducationAnnex = JSON.stringify(arr);
        }
        data.endTime = that.formatDate(data.endTime);
        if (that.eduForm.id) {
          updateResumeEducation(that.userId, data)
            .then(res => {
              if (res.code === 200) {
                that.$message.success("保存成功");
                that.onFindEduInfo(that.eduForm.id);
              } else {
                that.$message.error("保存失败");
              }
            })
            .finally(() => {
              that.onGetResumeEducationList();
              that.saveEduBth = false;
            });
        } else {
          addResumeEducation(that.userId, data)
            .then(res => {
              if (res.code === 200) {
                that.$message.success("保存成功");
                that.resetForm("eduForm");
                that.eduEditVisible = false;
              } else {
                that.$message.error("保存失败");
              }
            })
            .finally(() => {
              that.onGetResumeEducationList();
              that.saveEduBth = false;
            });
        }
      } catch (e) {
        that.saveEduBth = false;
      }
    },
    onAddEdu() {
      this.eduForm.id = null;
      this.eduEditVisible = true;
    },
    onEditEdu(id) {
      this.eduEditVisible = true;
      this.onFindEduInfo(id);
    },
    onDelEdu(id) {
      let that = this;
      that.loadingInstance = that.$loading(false);
      deleteResumeEducation(id)
        .then(res => {
          if (res.code === 200) {
            that.$message.success("删除成功");
          } else {
            that.$message.error("删除失败");
          }
        })
        .finally(() => {
          that.loadingInstance.close();
          that.onGetResumeEducationList();
        });
    },
    uploadResumeEducationFile() {
      this.$refs["eduUploader"].submit();
    },
    showEduFiles(id) {
      let that = this;
      this.onFindEduInfo(id, () => {
        if (
          that.eduForm.uploadEducationAnnex &&
          that.eduForm.uploadEducationAnnex.length > 0
        ) {
          that.eduFileVisible = true;
        } else {
          that.$alert("没有附件");
        }
      });
    },
    // 实习经历
    onGetResumeInternshipList() {
      let that = this;
      getResumeInternshipList(this.userId).then(res => {
        if (res && res.code === 200) {
          that.serviceCount++;
          if (res.data) {
            that.resumeInternshipInfoList = res.data.map(item => {
              if (item.startTime) {
                item.startTime = that.formatMonth(item.startTime);
              }
              if (item.endTime) {
                item.endTime = that.formatMonth(item.endTime);
              }
              return item;
            });
          }
        }
      });
    },
    onFindInternshipInfo(id) {
      let that = this;
      findResumeInternship(id).then(res => {
        if (res && res.code === 200) {
          if (res.data) {
            that.internshipForm = res.data;
          }
        }
      });
    },
    onEditInternship(id) {
      let that = this;
      that.internshipEditVisible = true;
      this.onFindInternshipInfo(id);
    },
    onSaveInternship() {
      this.$refs["internshipForm"].validate(valid => {
        if (valid) {
          this.saveInternship();
        } else {
          return false;
        }
      });
    },
    saveInternship() {
      let that = this;
      try {
        that.saveInternshipBth = true;
        that.internshipForm.startTime = that.formatDate(
          that.internshipForm.startTime
        );
        that.internshipForm.endTime = that.formatDate(
          that.internshipForm.endTime
        );
        if (that.internshipForm.startTime > that.internshipForm.endTime) {
          that.$message.error("结束时间不能早于开始时间");
          that.saveInternshipBth = false;
          return false;
        }
        if (that.internshipForm.id) {
          updateResumeInternship(that.userId, that.internshipForm)
            .then(res => {
              if (res.code === 200) {
                that.$message.success("保存成功");
              } else {
                that.$message.error("保存失败");
              }
            })
            .finally(() => {
              that.onGetResumeInternshipList();
              that.saveInternshipBth = false;
            });
        } else {
          addResumeInternship(that.userId, that.internshipForm)
            .then(res => {
              if (res.code === 200) {
                that.$message.success("保存成功");
              } else {
                that.$message.error("保存失败");
              }
            })
            .finally(() => {
              that.onGetResumeInternshipList();
              that.saveInternshipBth = false;
            });
        }
      } catch (e) {
        that.saveInternshipBth = false;
      }
    },
    onAddInternship() {
      this.internshipForm.id = null;
      this.internshipEditVisible = true;
    },
    onDelInternship(id) {
      let that = this;
      that.loadingInstance = that.$loading(false);
      deleteResumeInternship(id)
        .then(res => {
          if (res.code === 200) {
            that.$message.success("删除成功");
          } else {
            that.$message.error("删除失败");
          }
        })
        .finally(() => {
          that.loadingInstance.close();
          that.onGetResumeInternshipList();
        });
    },
    // 项目经历
    onGetResumeProjectList() {
      let that = this;
      getResumeProjectList(this.userId).then(res => {
        if (res && res.code === 200) {
          that.serviceCount++;
          if (res.data) {
            that.resumeProjectInfoList = res.data.map(item => {
              if (item.startTime) {
                item.startTime = that.formatMonth(item.startTime);
              }
              if (item.endTime) {
                item.endTime = that.formatMonth(item.endTime);
              }
              return item;
            });
          }
        }
      });
    },
    onFindProjectInfo(id) {
      let that = this;
      findResumeProject(id).then(res => {
        if (res && res.code === 200) {
          if (res.data) {
            that.projectForm = res.data;
          }
        }
      });
    },
    onEditProject(id) {
      this.projectEditVisible = true;
      this.onFindProjectInfo(id);
    },
    onSaveProject() {
      this.$refs["projectForm"].validate(valid => {
        if (valid) {
          this.saveProject();
        } else {
          return false;
        }
      });
    },
    saveProject() {
      let that = this;
      try {
        that.saveProjectBth = true;
        that.projectForm.startTime = that.formatDate(
          that.projectForm.startTime
        );
        that.projectForm.endTime = that.formatDate(that.projectForm.endTime);
        if (that.projectForm.startTime > that.projectForm.endTime) {
          that.$message.error("结束时间不能早于开始时间");
          that.saveInternshipBth = false;
          return false;
        }
        if (that.projectForm.id) {
          updateResumeProject(that.userId, that.projectForm)
            .then(res => {
              if (res.code === 200) {
                that.$message.success("保存成功");
              } else {
                that.$message.error("保存失败");
              }
            })
            .finally(() => {
              that.onGetResumeProjectList();
              that.saveProjectBth = false;
            });
        } else {
          addResumeProject(that.userId, that.projectForm)
            .then(res => {
              if (res.code === 200) {
                that.$message.success("保存成功");
              } else {
                that.$message.error("保存失败");
              }
            })
            .finally(() => {
              that.onGetResumeProjectList();
              that.saveProjectBth = false;
            });
        }
      } catch (e) {
        that.saveProjectBth = false;
      }
    },
    onAddProject() {
      this.projectForm.id = null;
      this.projectEditVisible = true;
    },
    onDelProject(id) {
      let that = this;
      that.loadingInstance = that.$loading(false);
      deleteResumeProject(id)
        .then(res => {
          if (res.code === 200) {
            that.$message.success("删除成功");
          } else {
            that.$message.error("删除失败");
          }
        })
        .finally(() => {
          that.loadingInstance.close();
          that.onGetResumeProjectList();
        });
    },
    // 培训经历
    onGetResumeTrainingList() {
      let that = this;
      getResumeTrainingList(this.userId).then(res => {
        if (res && res.code === 200) {
          that.serviceCount++;
          if (res.data) {
            that.resumeTrainingInfoList = res.data.map(item => {
              if (item.startTime) {
                item.startTime = that.formatMonth(item.startTime);
              }
              if (item.endTime) {
                item.endTime = that.formatMonth(item.endTime);
              }
              return item;
            });
          }
        }
      });
    },
    onFindTrainingInfo(id, callback) {
      let that = this;
      findResumeTraining(id).then(res => {
        if (res && res.code === 200) {
          if (res.data) {
            that.trainingForm = res.data;
            if (that.trainingForm.uploadProof) {
              that.trainingForm.uploadProof = JSON.parse(
                that.trainingForm.uploadProof
              )[0];
            }
            if (callback && callback instanceof Function) {
              callback();
            }
          }
        }
      });
    },
    onEditTraining(id) {
      this.trainingEditVisible = true;
      this.onFindTrainingInfo(id);
    },
    onSaveTraining() {
      let that = this;
      this.$refs["trainingForm"].validate(valid => {
        if (valid) {
          if (
            that.trainingForm.uploadProof &&
            that.trainingForm.uploadProof.startsWith("data:image")
          ) {
            this.uploadResumeTrainingFile();
          } else {
            that.saveTraining();
          }
        } else {
          return false;
        }
      });
    },
    saveTraining() {
      let that = this;
      try {
        that.saveTrainingBth = true;
        let data = this._.cloneDeep(this.trainingForm);
        if (data.uploadProof) {
          let arr = [];
          arr.push(data.uploadProof);
          data.uploadProof = JSON.stringify(arr);
        }
        if (that.trainingForm.id) {
          updateResumeTraining(that.userId, data)
            .then(res => {
              if (res.code === 200) {
                that.$message.success("保存成功");
              } else {
                that.$message.error("保存失败");
              }
            })
            .finally(() => {
              that.onGetResumeTrainingList();
              that.saveTrainingBth = false;
            });
        } else {
          addResumeTraining(that.userId, data)
            .then(res => {
              if (res.code === 200) {
                that.$message.success("保存成功");
                that.resetForm("trainingForm");
                that.trainingEditVisible = false;
              } else {
                that.$message.error("保存失败");
              }
            })
            .finally(() => {
              that.onGetResumeTrainingList();
              that.saveTrainingBth = false;
            });
        }
      } catch (e) {
        that.saveTrainingBth = false;
      }
    },
    onAddTraining() {
      this.trainingForm.id = null;
      this.trainingEditVisible = true;
    },
    onDelTraining(id) {
      let that = this;
      that.loadingInstance = that.$loading(false);
      deleteResumeTraining(id)
        .then(res => {
          if (res.code === 200) {
            that.$message.success("删除成功");
          } else {
            that.$message.error("删除失败");
          }
        })
        .finally(() => {
          that.loadingInstance.close();
          that.onGetResumeTrainingList();
        });
    },
    uploadResumeTrainingFile() {
      this.$refs["trainingUploader"].submit();
    },
    showTrainingFiles(id) {
      let that = this;
      this.onFindTrainingInfo(id, () => {
        if (
          that.trainingForm.uploadProof &&
          that.trainingForm.uploadProof.length > 0
        ) {
          that.trainingFileVisible = true;
        } else {
          that.$alert("没有附件");
        }
      });
    },
    // 工作经历
    onGetResumeWorkList() {
      let that = this;
      getResumeWorkList(this.userId).then(res => {
        if (res && res.code === 200) {
          that.serviceCount++;
          if (res.data) {
            that.resumeWorkInfoList = res.data.map(item => {
              if (item.startTime) {
                item.startTime = that.formatMonth(item.startTime);
              }
              if (item.endTime) {
                item.endTime = that.formatMonth(item.endTime);
              }
              return item;
            });
          }
        }
      });
    },
    onFindWorkInfo(id) {
      let that = this;
      findResumeWork(id).then(res => {
        if (res && res.code === 200) {
          if (res.data) {
            that.workForm = res.data;
          }
        }
      });
    },
    onEditWork(id) {
      let that = this;
      that.workEditVisible = true;
      this.onFindWorkInfo(id);
    },
    onSaveWork() {
      this.$refs["workForm"].validate(valid => {
        if (valid) {
          this.saveWork();
        } else {
          return false;
        }
      });
    },
    saveWork() {
      let that = this;
      try {
        that.saveWorkBth = true;
        that.workForm.startTime = that.formatDate(that.workForm.startTime);
        that.workForm.endTime = that.formatDate(that.workForm.endTime);
        if (that.workForm.startTime > that.workForm.endTime) {
          that.$message.error("结束时间不能早于开始时间");
          that.saveInternshipBth = false;
          return false;
        }
        if (that.workForm.id) {
          updateResumeWork(that.userId, that.workForm)
            .then(res => {
              if (res.code === 200) {
                that.$message.success("保存成功");
              } else {
                that.$message.error("保存失败");
              }
            })
            .finally(() => {
              that.onGetResumeWorkList();
              that.saveWorkBth = false;
            });
        } else {
          addResumeWork(that.userId, that.workForm)
            .then(res => {
              if (res.code === 200) {
                that.$message.success("保存成功");
              } else {
                that.$message.error("保存失败");
              }
            })
            .finally(() => {
              that.onGetResumeWorkList();
              that.saveWorkBth = false;
            });
        }
      } catch (e) {
        that.saveWorkBth = false;
      }
    },
    onAddWork() {
      this.workForm.id = null;
      this.workEditVisible = true;
    },
    onDelWork(id) {
      let that = this;
      that.loadingInstance = that.$loading(false);
      deleteResumeWork(id)
        .then(res => {
          if (res.code === 200) {
            that.$message.success("删除成功");
          } else {
            that.$message.error("删除失败");
          }
        })
        .finally(() => {
          that.loadingInstance.close();
          that.onGetResumeWorkList();
        });
    },
    // 所获荣誉
    onGetResumeCertificateList() {
      let that = this;
      getResumeCertificateList(this.userId).then(res => {
        if (res && res.code === 200) {
          that.serviceCount++;
          if (res.data) {
            that.resumeCertificateInfoList = res.data.map(item => {
              if (item.winningTime) {
                item.winningTime = that.formatMonth(item.winningTime);
              }
              return item;
            });
          }
        }
      });
    },
    onFindCertificateInfo(id, callback) {
      let that = this;
      findResumeCertificate(id).then(res => {
        if (res && res.code === 200) {
          if (res.data) {
            that.certificateForm = res.data;
            if (that.certificateForm.uploadCertificate) {
              that.certificateForm.uploadCertificate = JSON.parse(
                that.certificateForm.uploadCertificate
              )[0];
            }
            if (callback && callback instanceof Function) {
              callback();
            }
          }
        }
      });
    },
    onEditCertificate(id) {
      this.certificateEditVisible = true;
      this.onFindCertificateInfo(id);
    },
    onSaveCertificate() {
      let that = this;
      this.$refs["certificateForm"].validate(valid => {
        if (valid) {
          if (
            that.certificateForm.uploadCertificate &&
            that.certificateForm.uploadCertificate.startsWith("data:image")
          ) {
            this.uploadResumeCertificateFile();
          } else {
            that.saveCertificate();
          }
        } else {
          return false;
        }
      });
    },
    saveCertificate() {
      let that = this;
      try {
        that.saveCertificateBth = true;
        let data = this._.cloneDeep(this.certificateForm);
        data.winningTime = that.formatDate(data.winningTime);
        if (data.uploadCertificate) {
          if (data.uploadCertificate) {
            let arr = [];
            arr.push(data.uploadCertificate);
            data.uploadCertificate = JSON.stringify(arr);
          }
        }
        if (that.certificateForm.id) {
          updateResumeCertificate(that.userId, data)
            .then(res => {
              if (res.code === 200) {
                that.$message.success("保存成功");
              } else {
                that.$message.error("保存失败");
              }
            })
            .finally(() => {
              that.onGetResumeCertificateList();
              that.saveCertificateBth = false;
            });
        } else {
          addResumeCertificate(that.userId, data)
            .then(res => {
              if (res.code === 200) {
                that.$message.success("保存成功");
                that.resetForm("certificateForm");
                that.certificateEditVisible = false;
              } else {
                that.$message.error("保存失败");
              }
            })
            .finally(() => {
              that.onGetResumeCertificateList();
              that.saveCertificateBth = false;
            });
        }
      } catch (e) {
        that.saveCertificateBth = false;
      }
    },
    onAddCertificate() {
      this.certificateForm.id = null;
      this.certificateEditVisible = true;
    },
    onDelCertificate(id) {
      let that = this;
      that.loadingInstance = that.$loading(false);
      deleteResumeCertificate(id)
        .then(res => {
          if (res.code === 200) {
            that.$message.success("删除成功");
          } else {
            that.$message.error("删除失败");
          }
        })
        .finally(() => {
          that.loadingInstance.close();
          that.onGetResumeCertificateList();
        });
    },
    uploadResumeCertificateFile() {
      this.$refs["certificateUploader"].submit();
    },
    showCertificateFiles(id) {
      let that = this;
      this.onFindCertificateInfo(id, () => {
        if (
          that.certificateForm.uploadCertificate &&
          that.certificateForm.uploadCertificate.length > 0
        ) {
          that.certificateFileVisible = true;
        } else {
          that.$alert("没有附件");
        }
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.main-user {
  .dashboard {
    &-container {
      margin: 30px;
    }
    &-text {
      font-size: 30px;
      line-height: 46px;
    }
  }
  .card-fix-height {
    position: relative;
    height: calc(100vh - 50px - 84px - 15px - 40px - 51px - 52px - 2px - 30px);
  }
  .button {
    padding-bottom: 20px;
    img {
      margin: 10px;
    }
  }
  .blank {
    height: 20px;
  }
  .add_button {
    height: 40px;
    line-height: 40px;
    float: right;
    margin-right: 10px;
  }
  /deep/ .el-card__header {
    height: 40px;
    border-bottom: 1px solid #e3e6ec;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    background: -moz-linear-gradient(left, #e93c27 0%, #ffc1ba 30%, #fff 100%);
    background: -webkit-gradient(
      linear,
      left,
      right,
      color-stop(0%, #e93c27),
      color-stop(30%, #ffc1ba),
      color-stop(100%, #fff)
    );
    background: -webkit-linear-gradient(l, #e93c27 0%, #ffc1ba 30%, #fff 100%);
    background: -o-linear-gradient(left, #e93c27 0%, #ffc1ba 30%, #fff 100%);
    background: -ms-linear-gradient(left, #e93c27 0%, #ffc1ba 30%, #fff 100%);
    background: linear-gradient(to right, #e93c27 0%, #ffc1ba 30%, #fff 100%);
    padding: unset;
    span {
      color: #fff;
      line-height: 40px;
      margin-left: 20px;
      float: left;
      font-size: 14px;
    }
  }
}
</style>
